import { useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { ContextoGeral } from '../../contextos/ContextoGeral'
import AppAPI from '../../servicos/AppAPI'
import { relatorioMenuDisponivel } from '../../utils/relatorioModulo'
import { Spinner } from '../Spinner'

export default function RotaModuloRelatorio({ children }) {
	const { dados } = useContext(ContextoGeral)
	const [carregando, setCarregando] = useState(true)
	const [disponivel, setDisponivel] = useState(true)

	useEffect(() => {
		let cancelado = false

		async function verificar() {
			if (!dados?.dominio || !dados?.idProf || !dados?.token) {
				if (!cancelado) {
					setDisponivel(true)
					setCarregando(false)
				}
				return
			}

			try {
				const resposta = await AppAPI.buscarConfigRelatorio(dados)
				if (!cancelado) {
					setDisponivel(relatorioMenuDisponivel(resposta))
				}
			} catch {
				if (!cancelado) setDisponivel(true)
			} finally {
				if (!cancelado) setCarregando(false)
			}
		}

		verificar()
		return () => { cancelado = true }
	}, [dados?.dominio, dados?.idProf, dados?.token])

	if (carregando) {
		return <Spinner />
	}

	if (!disponivel) {
		return <Navigate to="/app/home" replace />
	}

	return children
}
